// components/CartSummary.js
import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";

const CartSummary = () => {
  const { cart } = useContext(CartContext);

  const subtotal = cart.reduce((sum, item) => sum + item.price * item.amount, 0);
  const delivery = 4; // fixed delivery
  const total = subtotal + delivery;

  return (
    <div className="bg-white text-black p-6 rounded shadow-md w-full">
      <h3 className="text-xl font-bold mb-4">Your Cart</h3>
      <div className="space-y-4">
        {cart.map((item) => (
          <div key={item.id} className="flex justify-between border-b pb-2">
            <div>
              <p className="font-semibold">{item.title}</p>
              <p className="text-sm text-gray-600">Qty: {item.amount}</p>
            </div>
            <p>${(item.amount * item.price).toFixed(2)}</p>
          </div>
        ))}
      </div>

      <div className="border-t mt-4 pt-4 space-y-2">
        <div className="flex justify-between">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between">
          <span>Delivery Charges</span>
          <span>${delivery.toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-bold text-lg border-t pt-2">
          <span>Grand Total</span>
          <span>${total.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;
